export const LEARNING_STATUS = {
    REPROBADO: -1,
    BLOCKED: 0,
    PENDIENTE: 1,
    VIEWED: 2,
    COMPLETED: 3,
    PENDING_CONNECTION: 4,
    IN_PROGRESS: 5,
}

export const LABEL_STATE = {
    label_course: 'Continuar curso',
    label_evaluation: 'EVALUARME',
    label_course_complete: 'Reintentar',
    label_course_pending: 'Pendiente de sync.',
}

export const OPTIONS = {
    OPTION_COURSE: 'OPTION_COURSE',
    OPTION_MODULE: 'OPTION_MODULE',
}
export const LABElS = {
    DOWNLOAD_CERTIFICATE: 'Descargar certificado',
    GO_BACK_COURSE: 'Volver al curso',
}
